/* eslint-disable no-unused-vars */
import { createAPIHandler, useOFetchRaw } from "@/plugins/ofetch";

const _CharityAPI = {
  /** @type {FetchAPI<import("../../../../backend/api/common/charity.js").getCharity>}  */
  getCharity: createAPIHandler(
    ([charityId, query = undefined]) => [
      `/api/common/charity/${encodeURIComponent(charityId)}`,
      { method: "GET", query }
    ]
  ),
};
export { _CharityAPI as CharityAPI };
const _ContactSupportAPI = {
  /** @type {FetchAPI<import("../../../../backend/api/common/contactSupport.js").createContactSupport>}  */
  createContactSupport: createAPIHandler(
    ([body = {}, query = undefined]) => [
      `/api/common/contact-support`,
      { method: "POST", body, query }
    ]
  ),
};
export { _ContactSupportAPI as ContactSupportAPI };
const _EventAPI = {
  /** @type {FetchAPI<import("../../../../backend/api/common/event.js").getEvent>}  */
  getEvent: createAPIHandler(
    ([eventId, query = undefined]) => [
      `/api/common/event/${encodeURIComponent(eventId)}`,
      { method: "GET", query }
    ]
  ),
};
export { _EventAPI as EventAPI };
const _FileDataAPI = {
  /** @type {FetchAPI<import("../../../../backend/api/common/fileData.js").uploadFileData>}  */
  uploadFileData: createAPIHandler(
    ([file, body = undefined, query = undefined]) => {
      const formData = new FormData();
      for (const key in body) formData.append(key, body[key]);
      formData.append("file", file);
      return [
        `/api/common/fileData`,
        { method: "POST", query, body: formData }
      ];
    }
  ),
  /** @type {FetchAPI<import("../../../../backend/api/common/fileData.js").uploadCharityLogoFile>}  */
  uploadCharityLogoFile: createAPIHandler(
    ([charityId, file, body = undefined, query = undefined]) => {
      const formData = new FormData();
      for (const key in body) formData.append(key, body[key]);
      formData.append("file", file);
      return [
        `/api/common/${encodeURIComponent(charityId)}/profile/logo`,
        { method: "POST", query, body: formData }
      ];
    }
  ),
};
export { _FileDataAPI as FileDataAPI };
const _FilesAPI = {
  /** @type {FetchAPI<import("../../../../backend/api/common/files.js").uploadFiles>}  */
  uploadFiles: createAPIHandler(
    ([file, body = undefined, query = undefined]) => {
      const formData = new FormData();
      for (const key in body) formData.append(key, body[key]);
      formData.append("file", file);
      return [
        `/api/common/files`,
        { method: "POST", query, body: formData }
      ];
    }
  ),
};
export { _FilesAPI as FilesAPI };
const _ToolkitAPI = {
  /** @type {FetchAPI<import("../../../../backend/api/common/toolkit.js").getToolkit>}  */
  getToolkit: createAPIHandler(
    ([query = undefined]) => [
      `/api/common/toolkit`,
      { method: "GET", query }
    ]
  ),
};
export { _ToolkitAPI as ToolkitAPI };
